enum NavigationStateDisplayType {
  ITEM_CONTAINER,
  TEST_REVIEW,
  WAIT_FOR_PROCTOR_RELEASE,
}

export default NavigationStateDisplayType;
